import type { AiAppCenterModule } from '../types'

/** 兼容旧 app=capacity；新入口用 distributionModule（key=distribution） */
export const capacityModule: AiAppCenterModule = {
  key: 'capacity',
  label: '配送系统',
  desc: '运力机构 / 运单调度 / 骑手管理',
  path: '/distribution',
  homePath: '/distribution/platform/overview',
  homeTitles: ['概况', '配送运营概况'],
  icon: 'ep:van',
  color: '#0d9488',
  // 勿加「配送管理」：与商城「配送管理」撞名
  aliases: ['配送系统运营端', '配送运营端', '紫金山骑手运营端', '紫金山骑手端'],
  hideFromMenu: true
}
